export default __webpack_public_path__ + "static/media/serviceBlock4.1ff932dc.jpeg";